"use client";
import React from "react";

import { ChatSidebar } from "./components/ChatSidebar";
import { ChatToggleButton } from "./components/ChatToggleButton";
import { ChatContext } from "./context/ChatContext";

export default function Chat() {
  return (
    <ChatContext>
      <ChatToggleButton />
      <ChatSidebar />
    </ChatContext>
  );
}
